import { ChainId } from '@uniswap/sdk'

export interface NetworkConfig {
  chainId: ChainId
  chainIdHex: string
  name: string
  nativeCurrency: {
    name: string
    symbol: string
    decimals: number
  }
  rpcUrls: string[]
  blockExplorerUrls: string[]
  routerAddress: string
  factoryAddress: string
  initCodeHash: string
}

export const NETWORKS: { [chainId in ChainId]?: NetworkConfig } = {
  [ChainId.K]: {
    chainId: ChainId.K,
    chainIdHex: process.env.REACT_APP_CHAIN_ID_HEX || '0x2f4',
    name: process.env.REACT_APP_CHAIN_NAME || 'K Chain',
    nativeCurrency: {
      name: process.env.REACT_APP_NATIVE_CURRENCY_NAME || 'K',
      symbol: process.env.REACT_APP_NATIVE_CURRENCY_SYMBOL || 'K',
      decimals: 18
    },
    rpcUrls: [process.env.REACT_APP_K_RPC_URL || process.env.REACT_APP_NETWORK_URL || 'https://mainnet.linksay.io'],
    blockExplorerUrls: [
      process.env.REACT_APP_K_EXPLORER_URL || process.env.REACT_APP_EXPLORER_URL || 'https://linksay.io'
    ],
    routerAddress:
      process.env.REACT_APP_K_ROUTER_ADDRESS ||
      process.env.REACT_APP_ROUTER_ADDRESS ||
      '0x0515222041C2Ac6C97f491c051939D77E92fF0e8',
    factoryAddress: process.env.REACT_APP_FACTORY_ADDRESS || '0x95EBB70AEE4C8EFD178DDecbcAA2A951f9125a5a',
    initCodeHash: '0xdf7b6cec4ed9f3014d5d70f259d92b9b3f1cd1651b6b775df5c5c83cda3110bd'
  },
  [ChainId.BSC]: {
    chainId: ChainId.BSC,
    chainIdHex: '0x38', // 56 in hex
    name: process.env.REACT_APP_BSC_CHAIN_NAME || 'BNB Smart Chain',
    nativeCurrency: {
      name: process.env.REACT_APP_BSC_NATIVE_CURRENCY_NAME || 'BNB',
      symbol: process.env.REACT_APP_BSC_NATIVE_CURRENCY_SYMBOL || 'BNB',
      decimals: 18
    },
    rpcUrls: [process.env.REACT_APP_BSC_RPC_URL || 'https://bscrpc.pancakeswap.finance'],
    blockExplorerUrls: [process.env.REACT_APP_BSC_EXPLORER_URL || 'https://bscscan.com'],
    routerAddress: process.env.REACT_APP_BSC_ROUTER_ADDRESS || '0x10ED43C718714eb63d5aA57B78B54704E256024E', // PancakeSwap Router
    factoryAddress: process.env.REACT_APP_BSC_FACTORY_ADDRESS || '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73', // PancakeSwap Factory
    initCodeHash: '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5'
  }
}

export const getNetworkConfig = (chainId: ChainId): NetworkConfig | undefined => {
  return NETWORKS[chainId]
}

export const getCurrentNetworkConfig = (): NetworkConfig | undefined => {
  const currentChainId = Number(process.env.REACT_APP_CHAIN_ID) || ChainId.K
  return getNetworkConfig(currentChainId as ChainId)
}

export const getRouterAddress = (chainId: ChainId): string => {
  const config = getNetworkConfig(chainId)
  return config?.routerAddress || ''
}

export const getFactoryAddress = (chainId: ChainId): string => {
  const config = getNetworkConfig(chainId)
  return config?.factoryAddress || ''
}

export const getInitCodeHash = (chainId: ChainId): string => {
  const config = getNetworkConfig(chainId)
  return config?.initCodeHash || ''
}
